'use strict';

/*global app*/
/*global services*/
/*global BasicQueue*/
/*global createObjectCallBack*/

function OutgoingControlQueue(containerId) {
  BasicQueue.call(this, containerId);

  this.box = null;

  this.init();
}

OutgoingControlQueue.prototype = $.extend({}, BasicQueue.prototype, {
  constructor: 'OutgoingControlQueue',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    return _this;
  },

  //----------------------------------------------------------------------------

  getProcessItemUrl: function getProcessItemUrl($item) {
    var _this = this;

    return _this.getProcessItemUrlBase($item) + '&Box=' + _this.box;
  },

  getProcessSelectedUrl: function getProcessSelectedUrl() {
    var _this = this;

    return _this.getProcessSelectedUrlBase() + '&Box=' + _this.box;
  },

  /*
  processItem: function processItem($item) {
    var _this = this;

    _this.scanBox($item);

    return _this;
  },

  processSelected: function processSelected() {
    var _this = this;

    _this.scanBox();

    return _this;
  },
  */

  //----------------------------------------------------------------------------

  doScanBox: function doScanBox($item) {
    var _this = this;

    var keyboard = services.get('keyboard');
    _this.box = keyboard.getValue();

    var confirm = services.get('confirm');
    confirm.close();

    if ($item && $item.length) {
      _this.doProcessItem($item);
    } else {
      _this.doProcessSelected();
    }

    return _this;
  },

  scanBox: function scanBox($item) {
    var _this = this;

    var keyboard = services.get('keyboard');

    //zjistime zdali uzivatel nechce zadat oznaceni palety
    var confirm = services.get('confirm');
    confirm.open({
      title: app.t('box.box_insert'),
      confirmCallBack: createObjectCallBack(_this, 'doScanBox', $item),
      confirmBtnTitle: app.t('form.submit_form'),
      rejectBtnTitle: app.t('form.do_not_submit_form'),
      buttonsSize: 'lg',
      width: 'md',
      content: '<p>' + app.t('box.box_insert_title') + '</p><div class="keyboard-wrapper"></div>'
    });

    confirm.contentDOM().find('.keyboard-wrapper').append(keyboard.getKeyboard());
    keyboard.reset();
    keyboard.setVirtualFocus();

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.processBulkAction = 'outgoing_control_process_bulk';

    _this.registerCallbacks();

    return _this;
  }
});
